import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpArticleDetail from "../components/HelpArticleDetail";

const HelpArticleDetailPage = () => {
  return (
    <>
      <Header />
      <HelpArticleDetail />
      <Footer />
    </>
  );
};

export default HelpArticleDetailPage;
